module.exports = __webpack_public_path__ + "img/mainBanner.7634b235.png";